import { CommonModule } from '@angular/common';
import { Component, EventEmitter, NgModule, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import _ from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { RepoQuoteRequestsService } from '../../../../data/repositories/repo-quoterequests.service';

@Component({
    selector: 'app-quotrequest-manage-presets',
    templateUrl: './quoterequest-manage-preset.component.html',
    standalone: false,
})
export class QuoteRequestManagePresetComponent implements OnInit {
    @Output() action = new EventEmitter();

    // @ts-ignore TS2564
    presetParams: () => { presets; type };
    // @ts-ignore TS7008
    presets;
    // @ts-ignore TS7008
    type;
    // @ts-ignore TS2564
    error: string;

    constructor(
        private bsModalRef: BsModalRef,
        private quoteReqRepo: RepoQuoteRequestsService
    ) {}

    ngOnInit() {
        this.presets = _.orderBy(this.presetParams().presets, ['Description']);
        this.type = this.presetParams().type;
    }

    validate() {
        // @ts-ignore TS2322
        this.error = undefined;

        for (let i = 0; i < this.presets.length; i++) {
            const current = this.presets[i];
            const duplicate = _.find(this.presets, (p) => {
                return p.Description === current.Description && p.ID_QuoteRequestPreset !== current.ID_QuoteRequestPreset;
            });
            if (duplicate) {
                this.error = "'" + current.Description + "' is a duplicate.";
                break;
            }
            if (!current.Description) {
                this.error = 'Description is required.';
                break;
            }
        }
    }

    // @ts-ignore TS7006
    deletePreset(preset) {
        // Reset first incase description or anything else was changed
        preset.entityAspect.rejectChanges();
        preset.IsDeleted = true;
        this.validate();
    }

    ok() {
        this.quoteReqRepo.Save(this.presets).then(() => {
            this.action.emit({ cancelled: false });
            this.bsModalRef.hide();
        });
    }

    cancel() {
        // @ts-ignore TS7006
        this.presets.forEach((preset) => {
            preset.entityAspect.rejectChanges();
        });
        this.action.emit({ cancelled: true });
        this.bsModalRef.hide();
    }
}
@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [QuoteRequestManagePresetComponent],
    exports: [QuoteRequestManagePresetComponent],
})
export class QuoteRequestManagePresetModule {}
